import React from 'react'
import FontAwesome from 'react-fontawesome'
import { connect } from 'react-redux'
import { OverlayTrigger, Popover } from 'react-bootstrap'

import { findRevisions } from '../actions/revision-actions'

import RevisionTable from './RevisionTable'

class RevisionsPopup extends React.Component {

  loadRevisions(entity, id, property) {
    this.props.findRevisions(entity,id,property)
  }

  render() {

    const popOverHistory = <Popover id='hist' style={{maxWidth: 1280}}>
        <RevisionTable revisions={this.props.revisions.revisions} type={this.props.type}/>
      </Popover>

    return (<OverlayTrigger trigger='click' placement='bottom' rootClose overlay={popOverHistory}>
      <FontAwesome id={`history-${this.props.property}`} name='history' size='lg' onClick={()=> this.loadRevisions(this.props.entity, this.props.entityId, this.props.property)}/>
    </OverlayTrigger>)
  }

}

export default connect(state=>{ return { revisions: state.revisions} }, { findRevisions })(RevisionsPopup)